import { StrictMode, lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'

// Shared styles needed by both branches. The widget panel and chat-bubble
// styles live here and are also consumed by admin's MessageActions /
// BubblePopup components.
import './styles.css'

// Route switch + code split. Visitors of /admin never download the widget
// bundle; chat-widget visitors never download admin panes / SSE log /
// scorecard plumbing. Vite splits each lazy() import into its own chunk
// automatically. The admin chunk also dynamically imports admin.css so
// dark-theme styles ship only with admin.
const isAdmin = window.location.pathname.startsWith('/admin')

// When the widget is embedded in a host page (Softr) via an iframe, tag the
// document so its background goes transparent — otherwise the widget's solid
// body background fills the whole iframe and covers the host page even when
// the chat is collapsed to just its launcher bubble. Standalone (top-level)
// visits are unaffected. Cross-origin access to window.top throws, which
// itself means we're embedded, so treat that as embedded too.
const isEmbedded = (() => {
  try {
    return window.self !== window.top
  } catch {
    return true
  }
})()
if (!isAdmin && isEmbedded) {
  document.documentElement.classList.add('ce1-embedded')
}

const Root = isAdmin
  ? lazy(async () => {
      await import('./admin/admin.css')
      return import('./admin/AdminApp')
    })
  : lazy(() => import('./App'))

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Suspense fallback is null — the page is blank for a fraction of a
        second while the right bundle streams in. Adding a spinner here
        would itself need a tiny bundle and add jank for fast paths. */}
    <Suspense fallback={null}>
      <Root />
    </Suspense>
  </StrictMode>,
)
